export default [
  {
    path: 'category/list',
    title : "Категории"
  },
  {
    path: 'channel/list',
    title : "Каналы",
    props: true
  },
  {
    path: 'publication/list/:id?',
    title : "Публикации",
    card: false,
    props: (route) => {
      if (route.params.series == null)
        route.params.series = route.query.series
      return route.params
    }
  },
  {
    path: 'series/list/:id?',
    title : "Серии",
    card: false,
    props: true
  },
  {
    path: 'user/list',
    title : "Пользователи",
    props: true
  }
]